// extracted by mini-css-extract-plugin
export default {"button":"DownloadButton_button__FOQN6","gradient":"DownloadButton_gradient__zalMQ","move":"DownloadButton_move__3vjIe"};